import ahoy from 'ahoy.js';

const RANKING_PAYLOAD_KEYS = {
  ranking_context_key: 'ranking_context_key',
  ranking_surface_type: 'surface_type',
  ranking_controller_name: 'controller_name',
  ranking_action_name: 'action_name',
  ranking_position: 'position',
  ranking_page_position: 'page_position',
  ranking_page: 'page',
  ranking_per_page: 'per_page',
  ranking_sort_by: 'sort_by',
  ranking_locale: 'locale',
  ranking_include_pro: 'include_pro',
  ranking_filters: 'filters',
  ranking_query: 'query',
  ranking_search_query_id: 'search_query_id',
  ranking_page_instance_id: 'page_instance_id',
  is_exploration_lane: 'is_exploration_lane',
  exploration_reason: 'exploration_reason'
};

const MARKETING_PAYLOAD_KEYS = [
  'gclid',
  'gbraid',
  'wbraid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'campaign_id',
  'adgroup_id',
  'creative_id',
  'target_id',
  'matchtype',
  'device',
  'network',
  'campaign_name',
  'adgroup_name',
  'landing_page',
  'referrer',
  'marketing_tracking_context'
];

export function currentUserTrackingContext() {
  let body = document.body;
  let context = body ? body.getAttribute('data-user-tracking-context') : null;

  if (context) {
    return context;
  }

  return body && body.getAttribute('data-logged-in') === 'true' ? 'legacy_logged_in' : 'legacy_guest';
}

export function shouldTrackVisitorEvents() {
  let trackableContexts = ['guest', 'customer', 'customer_with_subscription', 'legacy_guest'];
  return trackableContexts.includes(currentUserTrackingContext());
}

export function isFreeTrackingMode() {
  let body = document.body;
  return !!(body && body.getAttribute('data-free-tracking-mode') !== null);
}

export function shouldTrackGoogleAdsCatalogConversions() {
  let trackableContexts = ['guest', 'customer'];
  return trackableContexts.includes(currentUserTrackingContext()) && !isFreeTrackingMode();
}

export function buildTrackingPayload(basePayload, extraPayload = {}) {
  return Object.assign({}, currentMarketingTrackingPayload(), basePayload, extraPayload, {
    user_tracking_context: currentUserTrackingContext()
  });
}

export function trackAhoyEvent(eventName, payload) {
  if (typeof ahoy === 'object' && typeof ahoy.track === 'function') {
    ahoy.track(eventName, payload);
  }
}

export function extractRankingPayload(source) {
  let payload = {};

  Object.keys(RANKING_PAYLOAD_KEYS).forEach(function(sourceKey) {
    let targetKey = RANKING_PAYLOAD_KEYS[sourceKey];
    let value = source && source[sourceKey];
    if (typeof value !== 'undefined' && value !== null && value !== '') {
      payload[targetKey] = value;
    }
  });

  return payload;
}

export function currentMarketingTrackingPayload() {
  let body = document.body;
  let payload = {};

  MARKETING_PAYLOAD_KEYS.forEach(function(key) {
    let value = body ? body.getAttribute(`data-marketing-${key.replace(/_/g, '-')}`) : null;
    if (value !== null && value !== '') {
      payload[key] = value;
    }
  });

  return payload;
}

export function withRankingPayload(basePayload, source) {
  return Object.assign({}, extractRankingPayload(source), basePayload);
}

export function trackCatalogEvent(eventName, payload) {
  if (!shouldTrackVisitorEvents()) {
    return false;
  }

  let contextualPayload = buildTrackingPayload(payload);

  if (typeof plausible === 'function') {
    plausible(eventName, { props: contextualPayload });
  }

  trackAhoyEvent(eventName, Object.assign({}, contextualPayload, {
    categorization_processed: false
  }));

  return true;
}
